import ApplicantSSN from './ApplicantSSN';

export default ApplicantSSN;
